// extracted by mini-css-extract-plugin
export default {"btnAddCard":"BtnAddCard_btnAddCard__4rYCV","btnAddCardW":"BtnAddCard_btnAddCardW__U+vEU","iconPlus":"BtnAddCard_iconPlus__wnsWb"};